import { __assign } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
export var ChannelMembershipType;
(function (ChannelMembershipType) {
    ChannelMembershipType["DEFAULT"] = "DEFAULT";
    ChannelMembershipType["HIDDEN"] = "HIDDEN";
})(ChannelMembershipType || (ChannelMembershipType = {}));
export var AppInstanceUserMembershipSummary;
(function (AppInstanceUserMembershipSummary) {
    /**
     * @internal
     */
    AppInstanceUserMembershipSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AppInstanceUserMembershipSummary || (AppInstanceUserMembershipSummary = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["AccessDenied"] = "AccessDenied";
    ErrorCode["BadRequest"] = "BadRequest";
    ErrorCode["Conflict"] = "Conflict";
    ErrorCode["Forbidden"] = "Forbidden";
    ErrorCode["NotFound"] = "NotFound";
    ErrorCode["PhoneNumberAssociationsExist"] = "PhoneNumberAssociationsExist";
    ErrorCode["PreconditionFailed"] = "PreconditionFailed";
    ErrorCode["ResourceLimitExceeded"] = "ResourceLimitExceeded";
    ErrorCode["ServiceFailure"] = "ServiceFailure";
    ErrorCode["ServiceUnavailable"] = "ServiceUnavailable";
    ErrorCode["Throttled"] = "Throttled";
    ErrorCode["Throttling"] = "Throttling";
    ErrorCode["Unauthorized"] = "Unauthorized";
    ErrorCode["Unprocessable"] = "Unprocessable";
    ErrorCode["VoiceConnectorGroupAssociationsExist"] = "VoiceConnectorGroupAssociationsExist";
})(ErrorCode || (ErrorCode = {}));
export var BadRequestException;
(function (BadRequestException) {
    /**
     * @internal
     */
    BadRequestException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BadRequestException || (BadRequestException = {}));
export var Identity;
(function (Identity) {
    /**
     * @internal
     */
    Identity.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Name && { Name: SENSITIVE_STRING }))); };
})(Identity || (Identity = {}));
export var BatchChannelMemberships;
(function (BatchChannelMemberships) {
    /**
     * @internal
     */
    BatchChannelMemberships.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.InvitedBy && { InvitedBy: Identity.filterSensitiveLog(obj.InvitedBy) })), (obj.Members && { Members: obj.Members.map(function (item) { return Identity.filterSensitiveLog(item); }) }))); };
})(BatchChannelMemberships || (BatchChannelMemberships = {}));
export var BatchCreateChannelMembershipRequest;
(function (BatchCreateChannelMembershipRequest) {
    /**
     * @internal
     */
    BatchCreateChannelMembershipRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BatchCreateChannelMembershipRequest || (BatchCreateChannelMembershipRequest = {}));
export var BatchCreateChannelMembershipError;
(function (BatchCreateChannelMembershipError) {
    /**
     * @internal
     */
    BatchCreateChannelMembershipError.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BatchCreateChannelMembershipError || (BatchCreateChannelMembershipError = {}));
export var BatchCreateChannelMembershipResponse;
(function (BatchCreateChannelMembershipResponse) {
    /**
     * @internal
     */
    BatchCreateChannelMembershipResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.BatchChannelMemberships && {
        BatchChannelMemberships: BatchChannelMemberships.filterSensitiveLog(obj.BatchChannelMemberships),
    }))); };
})(BatchCreateChannelMembershipResponse || (BatchCreateChannelMembershipResponse = {}));
export var ForbiddenException;
(function (ForbiddenException) {
    /**
     * @internal
     */
    ForbiddenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ForbiddenException || (ForbiddenException = {}));
export var ServiceFailureException;
(function (ServiceFailureException) {
    /**
     * @internal
     */
    ServiceFailureException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ServiceFailureException || (ServiceFailureException = {}));
export var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    /**
     * @internal
     */
    ServiceUnavailableException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
export var ThrottledClientException;
(function (ThrottledClientException) {
    /**
     * @internal
     */
    ThrottledClientException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ThrottledClientException || (ThrottledClientException = {}));
export var UnauthorizedClientException;
(function (UnauthorizedClientException) {
    /**
     * @internal
     */
    UnauthorizedClientException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UnauthorizedClientException || (UnauthorizedClientException = {}));
export var ChannelMode;
(function (ChannelMode) {
    ChannelMode["RESTRICTED"] = "RESTRICTED";
    ChannelMode["UNRESTRICTED"] = "UNRESTRICTED";
})(ChannelMode || (ChannelMode = {}));
export var ChannelPrivacy;
(function (ChannelPrivacy) {
    ChannelPrivacy["PRIVATE"] = "PRIVATE";
    ChannelPrivacy["PUBLIC"] = "PUBLIC";
})(ChannelPrivacy || (ChannelPrivacy = {}));
export var Channel;
(function (Channel) {
    /**
     * @internal
     */
    Channel.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.Name && { Name: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING })), (obj.CreatedBy && { CreatedBy: Identity.filterSensitiveLog(obj.CreatedBy) }))); };
})(Channel || (Channel = {}));
export var ChannelBan;
(function (ChannelBan) {
    /**
     * @internal
     */
    ChannelBan.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) })), (obj.CreatedBy && { CreatedBy: Identity.filterSensitiveLog(obj.CreatedBy) }))); };
})(ChannelBan || (ChannelBan = {}));
export var ChannelBanSummary;
(function (ChannelBanSummary) {
    /**
     * @internal
     */
    ChannelBanSummary.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) }))); };
})(ChannelBanSummary || (ChannelBanSummary = {}));
export var ChannelMembership;
(function (ChannelMembership) {
    /**
     * @internal
     */
    ChannelMembership.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.InvitedBy && { InvitedBy: Identity.filterSensitiveLog(obj.InvitedBy) })), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) }))); };
})(ChannelMembership || (ChannelMembership = {}));
export var ChannelSummary;
(function (ChannelSummary) {
    /**
     * @internal
     */
    ChannelSummary.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Name && { Name: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING }))); };
})(ChannelSummary || (ChannelSummary = {}));
export var ChannelMembershipForAppInstanceUserSummary;
(function (ChannelMembershipForAppInstanceUserSummary) {
    /**
     * @internal
     */
    ChannelMembershipForAppInstanceUserSummary.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelSummary && { ChannelSummary: ChannelSummary.filterSensitiveLog(obj.ChannelSummary) }))); };
})(ChannelMembershipForAppInstanceUserSummary || (ChannelMembershipForAppInstanceUserSummary = {}));
export var ChannelMembershipSummary;
(function (ChannelMembershipSummary) {
    /**
     * @internal
     */
    ChannelMembershipSummary.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) }))); };
})(ChannelMembershipSummary || (ChannelMembershipSummary = {}));
export var ChannelMessagePersistenceType;
(function (ChannelMessagePersistenceType) {
    ChannelMessagePersistenceType["NON_PERSISTENT"] = "NON_PERSISTENT";
    ChannelMessagePersistenceType["PERSISTENT"] = "PERSISTENT";
})(ChannelMessagePersistenceType || (ChannelMessagePersistenceType = {}));
export var ChannelMessageType;
(function (ChannelMessageType) {
    ChannelMessageType["CONTROL"] = "CONTROL";
    ChannelMessageType["STANDARD"] = "STANDARD";
})(ChannelMessageType || (ChannelMessageType = {}));
export var ChannelMessage;
(function (ChannelMessage) {
    /**
     * @internal
     */
    ChannelMessage.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.Content && { Content: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING })), (obj.Sender && { Sender: Identity.filterSensitiveLog(obj.Sender) }))); };
})(ChannelMessage || (ChannelMessage = {}));
export var ChannelMessageSummary;
(function (ChannelMessageSummary) {
    /**
     * @internal
     */
    ChannelMessageSummary.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.Content && { Content: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING })), (obj.Sender && { Sender: Identity.filterSensitiveLog(obj.Sender) }))); };
})(ChannelMessageSummary || (ChannelMessageSummary = {}));
export var ChannelModeratedByAppInstanceUserSummary;
(function (ChannelModeratedByAppInstanceUserSummary) {
    /**
     * @internal
     */
    ChannelModeratedByAppInstanceUserSummary.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelSummary && { ChannelSummary: ChannelSummary.filterSensitiveLog(obj.ChannelSummary) }))); };
})(ChannelModeratedByAppInstanceUserSummary || (ChannelModeratedByAppInstanceUserSummary = {}));
export var ChannelModerator;
(function (ChannelModerator) {
    /**
     * @internal
     */
    ChannelModerator.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Moderator && { Moderator: Identity.filterSensitiveLog(obj.Moderator) })), (obj.CreatedBy && { CreatedBy: Identity.filterSensitiveLog(obj.CreatedBy) }))); };
})(ChannelModerator || (ChannelModerator = {}));
export var ChannelModeratorSummary;
(function (ChannelModeratorSummary) {
    /**
     * @internal
     */
    ChannelModeratorSummary.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Moderator && { Moderator: Identity.filterSensitiveLog(obj.Moderator) }))); };
})(ChannelModeratorSummary || (ChannelModeratorSummary = {}));
export var ConflictException;
(function (ConflictException) {
    /**
     * @internal
     */
    ConflictException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ConflictException || (ConflictException = {}));
export var Tag;
(function (Tag) {
    /**
     * @internal
     */
    Tag.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Key && { Key: SENSITIVE_STRING })), (obj.Value && { Value: SENSITIVE_STRING }))); };
})(Tag || (Tag = {}));
export var CreateChannelRequest;
(function (CreateChannelRequest) {
    /**
     * @internal
     */
    CreateChannelRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign(__assign({}, obj), (obj.Name && { Name: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING })), (obj.ClientRequestToken && { ClientRequestToken: SENSITIVE_STRING })), (obj.Tags && { Tags: obj.Tags.map(function (item) { return Tag.filterSensitiveLog(item); }) }))); };
})(CreateChannelRequest || (CreateChannelRequest = {}));
export var CreateChannelResponse;
(function (CreateChannelResponse) {
    /**
     * @internal
     */
    CreateChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateChannelResponse || (CreateChannelResponse = {}));
export var ResourceLimitExceededException;
(function (ResourceLimitExceededException) {
    /**
     * @internal
     */
    ResourceLimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceLimitExceededException || (ResourceLimitExceededException = {}));
export var CreateChannelBanRequest;
(function (CreateChannelBanRequest) {
    /**
     * @internal
     */
    CreateChannelBanRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateChannelBanRequest || (CreateChannelBanRequest = {}));
export var CreateChannelBanResponse;
(function (CreateChannelBanResponse) {
    /**
     * @internal
     */
    CreateChannelBanResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) }))); };
})(CreateChannelBanResponse || (CreateChannelBanResponse = {}));
export var CreateChannelMembershipRequest;
(function (CreateChannelMembershipRequest) {
    /**
     * @internal
     */
    CreateChannelMembershipRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateChannelMembershipRequest || (CreateChannelMembershipRequest = {}));
export var CreateChannelMembershipResponse;
(function (CreateChannelMembershipResponse) {
    /**
     * @internal
     */
    CreateChannelMembershipResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Member && { Member: Identity.filterSensitiveLog(obj.Member) }))); };
})(CreateChannelMembershipResponse || (CreateChannelMembershipResponse = {}));
export var CreateChannelModeratorRequest;
(function (CreateChannelModeratorRequest) {
    /**
     * @internal
     */
    CreateChannelModeratorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateChannelModeratorRequest || (CreateChannelModeratorRequest = {}));
export var CreateChannelModeratorResponse;
(function (CreateChannelModeratorResponse) {
    /**
     * @internal
     */
    CreateChannelModeratorResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelModerator && { ChannelModerator: Identity.filterSensitiveLog(obj.ChannelModerator) }))); };
})(CreateChannelModeratorResponse || (CreateChannelModeratorResponse = {}));
export var DeleteChannelRequest;
(function (DeleteChannelRequest) {
    /**
     * @internal
     */
    DeleteChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteChannelRequest || (DeleteChannelRequest = {}));
export var DeleteChannelBanRequest;
(function (DeleteChannelBanRequest) {
    /**
     * @internal
     */
    DeleteChannelBanRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteChannelBanRequest || (DeleteChannelBanRequest = {}));
export var DeleteChannelMembershipRequest;
(function (DeleteChannelMembershipRequest) {
    /**
     * @internal
     */
    DeleteChannelMembershipRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteChannelMembershipRequest || (DeleteChannelMembershipRequest = {}));
export var DeleteChannelMessageRequest;
(function (DeleteChannelMessageRequest) {
    /**
     * @internal
     */
    DeleteChannelMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteChannelMessageRequest || (DeleteChannelMessageRequest = {}));
export var DeleteChannelModeratorRequest;
(function (DeleteChannelModeratorRequest) {
    /**
     * @internal
     */
    DeleteChannelModeratorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteChannelModeratorRequest || (DeleteChannelModeratorRequest = {}));
export var DescribeChannelRequest;
(function (DescribeChannelRequest) {
    /**
     * @internal
     */
    DescribeChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelRequest || (DescribeChannelRequest = {}));
export var DescribeChannelResponse;
(function (DescribeChannelResponse) {
    /**
     * @internal
     */
    DescribeChannelResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Channel && { Channel: Channel.filterSensitiveLog(obj.Channel) }))); };
})(DescribeChannelResponse || (DescribeChannelResponse = {}));
export var DescribeChannelBanRequest;
(function (DescribeChannelBanRequest) {
    /**
     * @internal
     */
    DescribeChannelBanRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelBanRequest || (DescribeChannelBanRequest = {}));
export var DescribeChannelBanResponse;
(function (DescribeChannelBanResponse) {
    /**
     * @internal
     */
    DescribeChannelBanResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelBan && { ChannelBan: ChannelBan.filterSensitiveLog(obj.ChannelBan) }))); };
})(DescribeChannelBanResponse || (DescribeChannelBanResponse = {}));
export var NotFoundException;
(function (NotFoundException) {
    /**
     * @internal
     */
    NotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NotFoundException || (NotFoundException = {}));
export var DescribeChannelMembershipRequest;
(function (DescribeChannelMembershipRequest) {
    /**
     * @internal
     */
    DescribeChannelMembershipRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelMembershipRequest || (DescribeChannelMembershipRequest = {}));
export var DescribeChannelMembershipResponse;
(function (DescribeChannelMembershipResponse) {
    /**
     * @internal
     */
    DescribeChannelMembershipResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelMembership && { ChannelMembership: ChannelMembership.filterSensitiveLog(obj.ChannelMembership) }))); };
})(DescribeChannelMembershipResponse || (DescribeChannelMembershipResponse = {}));
export var DescribeChannelMembershipForAppInstanceUserRequest;
(function (DescribeChannelMembershipForAppInstanceUserRequest) {
    /**
     * @internal
     */
    DescribeChannelMembershipForAppInstanceUserRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelMembershipForAppInstanceUserRequest || (DescribeChannelMembershipForAppInstanceUserRequest = {}));
export var DescribeChannelMembershipForAppInstanceUserResponse;
(function (DescribeChannelMembershipForAppInstanceUserResponse) {
    /**
     * @internal
     */
    DescribeChannelMembershipForAppInstanceUserResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelMembership && {
        ChannelMembership: ChannelMembershipForAppInstanceUserSummary.filterSensitiveLog(obj.ChannelMembership),
    }))); };
})(DescribeChannelMembershipForAppInstanceUserResponse || (DescribeChannelMembershipForAppInstanceUserResponse = {}));
export var DescribeChannelModeratedByAppInstanceUserRequest;
(function (DescribeChannelModeratedByAppInstanceUserRequest) {
    /**
     * @internal
     */
    DescribeChannelModeratedByAppInstanceUserRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelModeratedByAppInstanceUserRequest || (DescribeChannelModeratedByAppInstanceUserRequest = {}));
export var DescribeChannelModeratedByAppInstanceUserResponse;
(function (DescribeChannelModeratedByAppInstanceUserResponse) {
    /**
     * @internal
     */
    DescribeChannelModeratedByAppInstanceUserResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Channel && { Channel: ChannelModeratedByAppInstanceUserSummary.filterSensitiveLog(obj.Channel) }))); };
})(DescribeChannelModeratedByAppInstanceUserResponse || (DescribeChannelModeratedByAppInstanceUserResponse = {}));
export var DescribeChannelModeratorRequest;
(function (DescribeChannelModeratorRequest) {
    /**
     * @internal
     */
    DescribeChannelModeratorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeChannelModeratorRequest || (DescribeChannelModeratorRequest = {}));
export var DescribeChannelModeratorResponse;
(function (DescribeChannelModeratorResponse) {
    /**
     * @internal
     */
    DescribeChannelModeratorResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelModerator && { ChannelModerator: ChannelModerator.filterSensitiveLog(obj.ChannelModerator) }))); };
})(DescribeChannelModeratorResponse || (DescribeChannelModeratorResponse = {}));
export var GetChannelMessageRequest;
(function (GetChannelMessageRequest) {
    /**
     * @internal
     */
    GetChannelMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetChannelMessageRequest || (GetChannelMessageRequest = {}));
export var GetChannelMessageResponse;
(function (GetChannelMessageResponse) {
    /**
     * @internal
     */
    GetChannelMessageResponse.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.ChannelMessage && { ChannelMessage: ChannelMessage.filterSensitiveLog(obj.ChannelMessage) }))); };
})(GetChannelMessageResponse || (GetChannelMessageResponse = {}));
export var GetMessagingSessionEndpointRequest;
(function (GetMessagingSessionEndpointRequest) {
    /**
     * @internal
     */
    GetMessagingSessionEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetMessagingSessionEndpointRequest || (GetMessagingSessionEndpointRequest = {}));
export var MessagingSessionEndpoint;
(function (MessagingSessionEndpoint) {
    /**
     * @internal
     */
    MessagingSessionEndpoint.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MessagingSessionEndpoint || (MessagingSessionEndpoint = {}));
export var GetMessagingSessionEndpointResponse;
(function (GetMessagingSessionEndpointResponse) {
    /**
     * @internal
     */
    GetMessagingSessionEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetMessagingSessionEndpointResponse || (GetMessagingSessionEndpointResponse = {}));
export var ListChannelBansRequest;
(function (ListChannelBansRequest) {
    /**
     * @internal
     */
    ListChannelBansRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelBansRequest || (ListChannelBansRequest = {}));
export var ListChannelBansResponse;
(function (ListChannelBansResponse) {
    /**
     * @internal
     */
    ListChannelBansResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING })), (obj.ChannelBans && { ChannelBans: obj.ChannelBans.map(function (item) { return ChannelBanSummary.filterSensitiveLog(item); }) }))); };
})(ListChannelBansResponse || (ListChannelBansResponse = {}));
export var ListChannelMembershipsRequest;
(function (ListChannelMembershipsRequest) {
    /**
     * @internal
     */
    ListChannelMembershipsRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelMembershipsRequest || (ListChannelMembershipsRequest = {}));
export var ListChannelMembershipsResponse;
(function (ListChannelMembershipsResponse) {
    /**
     * @internal
     */
    ListChannelMembershipsResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.ChannelMemberships && {
        ChannelMemberships: obj.ChannelMemberships.map(function (item) { return ChannelMembershipSummary.filterSensitiveLog(item); }),
    })), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelMembershipsResponse || (ListChannelMembershipsResponse = {}));
export var ListChannelMembershipsForAppInstanceUserRequest;
(function (ListChannelMembershipsForAppInstanceUserRequest) {
    /**
     * @internal
     */
    ListChannelMembershipsForAppInstanceUserRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelMembershipsForAppInstanceUserRequest || (ListChannelMembershipsForAppInstanceUserRequest = {}));
export var ListChannelMembershipsForAppInstanceUserResponse;
(function (ListChannelMembershipsForAppInstanceUserResponse) {
    /**
     * @internal
     */
    ListChannelMembershipsForAppInstanceUserResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.ChannelMemberships && {
        ChannelMemberships: obj.ChannelMemberships.map(function (item) {
            return ChannelMembershipForAppInstanceUserSummary.filterSensitiveLog(item);
        }),
    })), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelMembershipsForAppInstanceUserResponse || (ListChannelMembershipsForAppInstanceUserResponse = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASCENDING"] = "ASCENDING";
    SortOrder["DESCENDING"] = "DESCENDING";
})(SortOrder || (SortOrder = {}));
export var ListChannelMessagesRequest;
(function (ListChannelMessagesRequest) {
    /**
     * @internal
     */
    ListChannelMessagesRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelMessagesRequest || (ListChannelMessagesRequest = {}));
export var ListChannelMessagesResponse;
(function (ListChannelMessagesResponse) {
    /**
     * @internal
     */
    ListChannelMessagesResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING })), (obj.ChannelMessages && {
        ChannelMessages: obj.ChannelMessages.map(function (item) { return ChannelMessageSummary.filterSensitiveLog(item); }),
    }))); };
})(ListChannelMessagesResponse || (ListChannelMessagesResponse = {}));
export var ListChannelModeratorsRequest;
(function (ListChannelModeratorsRequest) {
    /**
     * @internal
     */
    ListChannelModeratorsRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelModeratorsRequest || (ListChannelModeratorsRequest = {}));
export var ListChannelModeratorsResponse;
(function (ListChannelModeratorsResponse) {
    /**
     * @internal
     */
    ListChannelModeratorsResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING })), (obj.ChannelModerators && {
        ChannelModerators: obj.ChannelModerators.map(function (item) { return ChannelModeratorSummary.filterSensitiveLog(item); }),
    }))); };
})(ListChannelModeratorsResponse || (ListChannelModeratorsResponse = {}));
export var ListChannelsRequest;
(function (ListChannelsRequest) {
    /**
     * @internal
     */
    ListChannelsRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelsRequest || (ListChannelsRequest = {}));
export var ListChannelsResponse;
(function (ListChannelsResponse) {
    /**
     * @internal
     */
    ListChannelsResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Channels && { Channels: obj.Channels.map(function (item) { return ChannelSummary.filterSensitiveLog(item); }) })), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelsResponse || (ListChannelsResponse = {}));
export var ListChannelsModeratedByAppInstanceUserRequest;
(function (ListChannelsModeratedByAppInstanceUserRequest) {
    /**
     * @internal
     */
    ListChannelsModeratedByAppInstanceUserRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelsModeratedByAppInstanceUserRequest || (ListChannelsModeratedByAppInstanceUserRequest = {}));
export var ListChannelsModeratedByAppInstanceUserResponse;
(function (ListChannelsModeratedByAppInstanceUserResponse) {
    /**
     * @internal
     */
    ListChannelsModeratedByAppInstanceUserResponse.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Channels && {
        Channels: obj.Channels.map(function (item) { return ChannelModeratedByAppInstanceUserSummary.filterSensitiveLog(item); }),
    })), (obj.NextToken && { NextToken: SENSITIVE_STRING }))); };
})(ListChannelsModeratedByAppInstanceUserResponse || (ListChannelsModeratedByAppInstanceUserResponse = {}));
export var RedactChannelMessageRequest;
(function (RedactChannelMessageRequest) {
    /**
     * @internal
     */
    RedactChannelMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RedactChannelMessageRequest || (RedactChannelMessageRequest = {}));
export var RedactChannelMessageResponse;
(function (RedactChannelMessageResponse) {
    /**
     * @internal
     */
    RedactChannelMessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RedactChannelMessageResponse || (RedactChannelMessageResponse = {}));
export var SendChannelMessageRequest;
(function (SendChannelMessageRequest) {
    /**
     * @internal
     */
    SendChannelMessageRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.Content && { Content: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING })), (obj.ClientRequestToken && { ClientRequestToken: SENSITIVE_STRING }))); };
})(SendChannelMessageRequest || (SendChannelMessageRequest = {}));
export var SendChannelMessageResponse;
(function (SendChannelMessageResponse) {
    /**
     * @internal
     */
    SendChannelMessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SendChannelMessageResponse || (SendChannelMessageResponse = {}));
export var UpdateChannelRequest;
(function (UpdateChannelRequest) {
    /**
     * @internal
     */
    UpdateChannelRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Name && { Name: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING }))); };
})(UpdateChannelRequest || (UpdateChannelRequest = {}));
export var UpdateChannelResponse;
(function (UpdateChannelResponse) {
    /**
     * @internal
     */
    UpdateChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateChannelResponse || (UpdateChannelResponse = {}));
export var UpdateChannelMessageRequest;
(function (UpdateChannelMessageRequest) {
    /**
     * @internal
     */
    UpdateChannelMessageRequest.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Content && { Content: SENSITIVE_STRING })), (obj.Metadata && { Metadata: SENSITIVE_STRING }))); };
})(UpdateChannelMessageRequest || (UpdateChannelMessageRequest = {}));
export var UpdateChannelMessageResponse;
(function (UpdateChannelMessageResponse) {
    /**
     * @internal
     */
    UpdateChannelMessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateChannelMessageResponse || (UpdateChannelMessageResponse = {}));
export var UpdateChannelReadMarkerRequest;
(function (UpdateChannelReadMarkerRequest) {
    /**
     * @internal
     */
    UpdateChannelReadMarkerRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateChannelReadMarkerRequest || (UpdateChannelReadMarkerRequest = {}));
export var UpdateChannelReadMarkerResponse;
(function (UpdateChannelReadMarkerResponse) {
    /**
     * @internal
     */
    UpdateChannelReadMarkerResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateChannelReadMarkerResponse || (UpdateChannelReadMarkerResponse = {}));
//# sourceMappingURL=models_0.js.map